<template>
  <div class="card-chat">
    <div class="card-chat-header">
      <h4>Zprávy</h4>
      <span class="icon icon-close" @click="$emit('close')"></span>
    </div>

    <ul class="list-unstyled conversations">
      <li class="message-item" v-for="conversation in conversations" :key="conversation.id">
        <div class="user">
          <h4>{{ conversation.fullname }}</h4>

          <span class="info">Počet nepřečtených zpráv</span>
          <br />
          <span class="info">
            <strong>{{ conversation.messages.length }}</strong>
          </span>

          <br />

          <template v-if="conversation.last_message">
            <span class="ago">Poslední zpráva ze</span>
            <br />
            <span class="ago">
              <strong>
                {{
                  moment(conversation.last_message.created_at).format(
                    'DD.MM.YYYY HH:mm'
                  )
                }}
              </strong>
            </span>
          </template>

          <a :href="`/products/${conversation.product_id}?conversation=${conversation.id}`">
            <button type="button" class="btn btn-primary btn-sm btn-block">
              Konverzace
            </button>
          </a>
        </div>
        <div class="messages">
          <p class="message" v-for="(message, i) in conversation.messages" :key="i">
            {{ message.body }}
          </p>
          <div v-if="conversation.messages.length === 0" class="empty">
            Žádné nepřečtené zprávy
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      conversations: []
    }
  },
  async mounted() {
    this.conversations = await axios
      .get(`/chat/conversations?product_id=${this.productId}`)
      .then((r) => r.data)
  }
}
</script>
